function handleRequests({ dispatch, commit, requests, ...rest }) {
  const callTimestamp = Date.now()
  commit('drills_set', { key: 'drill_call_timestamp', value: callTimestamp })

  Promise.all(requests).then(values => {
    const responses = (values || []).map(i => i.response).filter(i => i)
    const errors = (values || []).map(i => i.error).filter(i => i)
    // console.log({ responses, errors, ...rest })
    dispatch('drills_handle_update', { responses, errors, callTimestamp, ...rest })
  })
}
const drillsCalls = {
  async api_drills_get({ dispatch }) {
    return dispatch('api_call', {
      endpoint: 'poker/practice/drills/',
      params: {
        with_totals: true,
        // public: true,
        // with_totals: false,
        // public: false,
      },
      hasCancel: false,
      mutation: 'api_poker_drills',
    })
  },
  async api_drill_post({ dispatch, commit }, { items, ...rest }) {
    const requests = items.map(item =>
      dispatch('api_call', {
        method: 'POST',
        endpoint: `poker/practice/drills/`,
        hasCancel: false,
        data: item,
        mutation: 'api_poker_drill',
      }),
    )
    handleRequests({ dispatch, commit, requests, items, ...rest })
  },
  async api_drill_patch({ dispatch, commit }, { items, ...rest }) {
    // console.log(items)
    const requests = items.map(item =>
      dispatch('api_call', {
        method: 'PATCH',
        endpoint: `poker/practice/drills/${item.id}/`,
        hasCancel: false,
        data: item,
        // mutation: 'api_poker_drill',
        // BE heavy can be slow
        // params: {
        //     with_totals: true,
        // },
      }),
    )
    handleRequests({ dispatch, commit, requests, items, ...rest })
  },
  async api_drill_delete({ dispatch, commit }, { ids, ...rest }) {
    const requests = ids.map((id, idx) =>
      dispatch('api_call', {
        method: 'DELETE',
        endpoint: `poker/practice/drills/${id}/`,
        // endpoint: `poker/practice/drills/${id}/${idx === 0 ? 'ss' : ''}`,
        hasCancel: false,
        // mutation: 'api_poker_drill',
      }),
    )
    handleRequests({ dispatch, commit, requests, ids, ...rest })
  },
}

export default drillsCalls
